import styled from 'styled-components';

export const RequestHeaderContainer = styled.div`
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .ant-tag {
    font-size: 0.9rem;
    padding: 4px 8px;
  }
`;
